import { get } from "@/services/NPS/Stepper/axiosUitils";
import { DownloadStatementResponse } from "@/utils/types/DownloadStatement";

const basePath = "/nps/cra/sot/";

export default class DownloadStatementService {
  getDownloadStatement = async (): Promise<DownloadStatementResponse> => {
    return await get<DownloadStatementResponse>(basePath);
  };
}
